import _get from "lodash/get";
export var generateUUID = function generateUUID() {
  if (typeof _get(window, 'NWA.utils.generateUUID') === 'function') {
    // DEPRECATED
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[DEPRECATED] Use nwa.generatePageViewId instead');
    }

    return window.NWA.utils.generateUUID();
  }

  return '';
};